const FORM_STEP = 0;
const SUMMARY_STEP = 1;
const SUCCESS_STEP = 2;
const ERROR_STEP = 3;

export const TradeFormSteps: Record<string, number> = {
  FORM: FORM_STEP,
  SUMMARY: SUMMARY_STEP,
  SUCCESS: SUCCESS_STEP,
  ERROR: ERROR_STEP,
};
